import React from 'react'

export default function ProjectLogs({ setLogs }) {
    const dummyData = [
        { id: 1, user: "Mark Otto", time: "10:30 AM", ip: "192.168.1.1", browser: "Chrome" },
        { id: 2, user: "John Doe", time: "11:15 AM", ip: "172.16.0.2", browser: "Firefox" },
        { id: 3, user: "Jane Smith", time: "01:45 PM", ip: "203.0.113.5", browser: "Safari" },
        { id: 4, user: "Alice Johnson", time: "03:10 PM", ip: "198.51.100.12", browser: "Edge" },
        { id: 5, user: "Bob Brown", time: "04:00 PM", ip: "10.0.0.5", browser: "Opera" },
        { id: 6, user: "Charlie Davis", time: "09:20 AM", ip: "203.112.45.78", browser: "Chrome" },
        { id: 7, user: "Daniel White", time: "07:30 PM", ip: "115.87.12.45", browser: "Firefox" },
        { id: 8, user: "Emma Wilson", time: "06:15 PM", ip: "154.122.67.89", browser: "Safari" },
        { id: 9, user: "Frank Harris", time: "02:50 PM", ip: "210.56.34.76", browser: "Edge" },
        { id: 10, user: "Grace Moore", time: "05:05 AM", ip: "198.162.88.99", browser: "Opera" }
    ]
    return (
        <div className='project__logs'>
            <div className="back__btn" onClick={() => setLogs(false)}>
                <img src="/back-arrow.svg" alt="" />
                Back
            </div>
            <div className="table__header end">
                <input type="text" placeholder='User Search' className='form-control' />
            </div>
            <div className="table-wrapper">
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>Sl No</th>
                        <th>User</th>
                        <th>Time</th>
                        <th>IP Address</th>
                        <th>Browser</th>
                    </tr>
                </thead>
                <tbody>
                {dummyData.map((item) => (
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.user}</td>
                        <td>{item.time}</td>
                        <td>{item.ip}</td>
                        <td>{item.browser}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
            
        </div>
    )
}
